var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Field',{attrs:{"name":_vm.name,"value":_vm.value,"label":"BP","autocomplete":"new-password","errors":_vm.errors},on:{"input":_vm.handleInput,"focus":_vm.handleFocus,"blur":_vm.handleBlur}})}
var staticRenderFns = []

export { render, staticRenderFns }